module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "IndexPortofolios"
    }
  }, [_c('section', {
    staticClass: "sub--header diagonal-shadow mg-bottom-diagonal"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "box-desc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tPortofolio\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi distinctio iusto sunt ducimus eos nesciunt impedit ex ipsam. Ratione necessitatibus, beatae nesciunt, excepturi error exercitationem. Maxime voluptatem, fugit laboriosam assumenda?\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-warning",
    attrs: {
      "to": 'apply-project'
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t  Konsultasikan pada kami\n\t\t\t\t\t\t\t")])], 1)])])])]), _vm._v(" "), _c('section', {
    staticClass: "section--wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.portofolio), function(project) {
    return _c('div', {
      key: project.id,
      staticClass: "col-md-3"
    }, [_c('div', {
      staticClass: "list-portofolio"
    }, [_c('div', {
      staticClass: "list-portofolio__image"
    }, [_c('img', {
      attrs: {
        "src": project.client_logo_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "box-description"
    }, [_c('router-link', {
      staticClass: "title",
      attrs: {
        "to": 'portofolios/detail/3'
      }
    }, [_vm._v("\n                    " + _vm._s(project.title) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "type"
    }, [_vm._v("\n                    " + _vm._s(project.client_name) + "\n                  ")])], 1)])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tlatest project\n\t\t\t\t\t\t\t")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-739fb421","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/portofolios/IndexPortofolios.vue
// module id = 81
// module chunks = 0